const GUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

type AccessTokenPayload = {
  organization_id?: unknown;
};

export function hasValidOrganizationIdClaim(accessToken: string): boolean {
  const encodedPayload = accessToken.split(".")[1];
  if (!encodedPayload) return false;

  try {
    const base64Payload = encodedPayload.replace(/-/g, "+").replace(/_/g, "/");
    const decodedPayload = atob(
      base64Payload.padEnd(base64Payload.length + ((4 - (base64Payload.length % 4)) % 4), "="),
    );
    const payload = JSON.parse(decodedPayload) as AccessTokenPayload;

    return (
      typeof payload.organization_id === "string" &&
      payload.organization_id.trim() !== "" &&
      payload.organization_id !== "00000000-0000-0000-0000-000000000000" &&
      GUID_PATTERN.test(payload.organization_id)
    );
  } catch {
    return false;
  }
}
